var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('notifications',{attrs:{"position":"bottom right"}}),_c('vue-progress-bar'),_c('keep-alive',[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_c('GoToTop')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }